import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {DevilsCrossRoad} from "../../DevilsCrossRoad";


export class DCRoadAvalancheIdlePresentation implements FlowStatePresentation {

    constructor() {
    }

    start(flowStateController:FlowStateController):void {
        if(DevilsCrossRoad.model.isRestore && DevilsCrossRoad.model.initData.nextMode.includes("AVALANCHE")) {
            SlotGame.keypadPlugin.setZeroBetSpinCounter(DevilsCrossRoad.model.data.freespinsLeft - 1);
        }
        SlotGame.apiPlugin.betHandler.zeroBet();
        flowStateController.finish();
    }
}